<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="page-wrapper">
      <v-layout wrap>
        <v-flex class="title-screen" xs12>
          <span>Announcements</span>
        </v-flex>
        <div class="mb-32 title-description">
          Make an announcement to the attendees of your event through the mobile app to keep them
          updated on everything related to the event. Here you can add or edit the announcements.
        </div>
        <v-flex class="pb-16" xs12 >
          <main-button depressed @click="goTo(routes.organizer.newAnnouncement)">
            Create announcement
          </main-button>
        </v-flex>
        <v-flex xs12>
          <data-table
            :items="announcements"
            item-clickable
            :headers="[
              { text: 'Title', align: 'left', value: 'title' },
              { text: 'Date', align: 'left', value: 'createdAt' },
              { text: 'Send notification', align: 'left', value: 'isPushNotification' },
            ]"
            @item-click="
              goTo(routes.organizer.displayAnnouncement, {
                eventId: eventId,
                id: $event.id,
              })
            "
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import DataTable from '../shared/data-table'
import Spinner from '../shared/spinner'
import { GET_EVENT_ANNOUNCEMENT } from '../../graphql/announcement.graphql.js'
import { formatDate } from '../../utils'
import { apolloClient } from '../../apollo'
import { deleteAnnouncement, getAnnouncements } from '../../http.js'

export default {
  name: 'announcement-list-container',
  components: {
    Spinner,
    DataTable,
  },
  props: {
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      announcements: [],
    }
  },
  apollo: {
    getEventAnnouncements: {
      query: GET_EVENT_ANNOUNCEMENT,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const { getAnnouncements: announcements } = data
          this.announcements = announcements.map(a => {
            return {
              ...a,
              createdAt: formatDate(a.createdAt),
            }
          })
        }
      },
    },
  },
  async formatAnnouncements(announcements) {
    return announcements.map(a => {
      return {
        ...a,
        createdAt: formatDate(a.createdAt),
      }
    })
  },
  async refetchAnnouncements() {
    const announcements = await getAnnouncements(this.eventId)
    this.announcements = this.formatAnnouncements(announcements)
  },
  async updated() {
    await this.refetchAnnouncements()
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .page-wrapper{
    margin-top: 1.5rem !important
  }
}
</style>
